import { Route } from '@angular/router';
import { BI_LANDING_ROUTES } from './routing/bi-landing.routes';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard/dashboard/dashboard' },
  {
    path: 'dashboard',
    pathMatch: 'full',
    redirectTo: 'dashboard/dashboard/dashboard',
  },
  {
    path: 'commercial',
    pathMatch: 'full',
    redirectTo: 'commercial/commercial/commercial',
  },
  {
    path: 'treasury',
    pathMatch: 'full',
    redirectTo: 'treasury/treasury/treasury',
  },
  {
    path: 'construction',
    pathMatch: 'full',
    redirectTo: 'construction/construction/construction',
  },
  {
    path: 'accounting',
    pathMatch: 'full',
    redirectTo: 'accounting/accounting/accounting',
  },
  { path: 'audit', pathMatch: 'full', redirectTo: 'audit/audit/audit' },
  {
    // App Shell: única instancia del layout. Las páginas solo aportan contenido
    // y declaran su marco en `data.chrome`.
    path: '',
    loadComponent: () =>
      import('./shell/bi-shell.component').then(m => m.BiShellComponent),
    children: [...BI_LANDING_ROUTES],
  },
];
